export const DUMO_PATH = '/dumo'
export const ACCOUNT_PATH = '/account'
export const LOGIN_PATH = '/login'
export const SIGNUP_PATH = '/signup'
export const ACCOUNT_FORM_NAME = 'account'
export const LOGIN_FORM_NAME = 'login'
export const SIGNUP_FORM_NAME = 'signup'
export const NEW_PROJECT_FORM_NAME = 'newProject'

export const STAGE_TASK_CHOICE = 'STAGE_TASK_CHOICE'
export const STAGE_TASK_COUNTER = 'STAGE_TASK_COUNTER'
export const STAGE_BREAK_CHOICE = 'STAGE_BREAK_CHOICE'
export const STAGE_BREAK_COUNTER = 'STAGE_BREAK_COUNTER'



// WEBPACK FOOTER //
// ./src/constants.js